
const tourSteps = [
  {
    selector: '.saras-tour-home-main-menu',
    content: 'Click here to access the applications main menu',
  },
  {
    selector: '.saras-tour-home-side-menu',
    content: 'Side menu provides quick access to various sections of the application.',
  },
  {
    selector: '.saras-tour-home-side-menu-home',
    content: 'Go to home and access the main insights dashboard.',
  },
  {
    selector: '.saras-tour-home-side-menu-recent',
    content: 'Go to recent menus from here',
  },
  {
    selector: '.saras-tour-home-top-menu',
    content: 'From the top menu you can access help, user profile, and other settings.',
  },
  {
    selector: '.saras-tour-insight',
    content: 'This dashboard provides you quick insights into your data and activities.',
  },
  {
    selector: '.saras-tour-insight-action-date',
    content: 'You can quickly filter all the insights by updating the date range here.',
  },
  {
    selector: '.saras-tour-insight-action-refresh',
    content: 'Refresh all the insights in one click',
  },  
  {
    selector: '.saras-tour-insight-action-switch',
    content: 'Switch between different templates of insights targeting specific areas of interest.',
  },
  {
    selector: '.saras-tour-insight-view-options',
    content: 'Switch between different perspectives of this insight eg: By Value or By Count',
  },
  {
    selector: '.saras-tour-insight-view-action-date',
    content: 'You can quickly filter this insight by updating the date range here.',
  },
  {
    selector: '.saras-tour-insight-view-action-filter',
    content: 'Gain access to more filters to narrow down to the data of particular interest.',
  },
  {
    selector: '.saras-tour-insight-view-action-refresh',
    content: 'Refresh the data of this insight',
  },
];

export default tourSteps;
